import { Container, GridItem, Stack, Visibility } from "@octopus-energy/coral/atoms"
import { storyblokEditable } from "@octopus-energy/coral/storyblok"
import { AnimatedNumber, ConstantineHidden, FadeIn, Text } from "@/features/greenEnergy"
import { type SbBlokGreenEnergyHouseholds } from "../../types"

interface DynamicRenewableEnergyProps {
    blok: SbBlokGreenEnergyHouseholds
}

export function DynamicEnergyHouseholds({ blok }: DynamicRenewableEnergyProps) {
    return (
        <GridItem
            gridRowStart={{ base: 11, xl: 7 }}
            gridColumnStart={{ base: 1, xl: 3 }}
            gridRowEnd={{ base: 12, xl: 8 }}
            gridColumnEnd={{ base: 3, xl: 6 }}
        >
            <FadeIn {...storyblokEditable(blok)}>
                <Container paddingY={{ base: undefined, xl: "lg" }}>
                    <Stack
                        flexDirection="column"
                        gap="none"
                    >
                        <Stack
                            flexDirection="column"
                            gap="none"
                        >
                            <Text>{blok.line1}</Text>
                            <Text>{blok.line2}</Text>
                        </Stack>
                        <Stack
                            gap="none"
                            fullWidth
                            flexDirection={{ base: "column", xl: "row" }}
                            alignItems={{ base: undefined, xl: "flex-end" }}
                        >
                            <Visibility hidden={{ base: true, xl: false }}>
                                <ConstantineHidden />
                            </Visibility>
                            <AnimatedNumber
                                target={blok.thousands}
                                final={`${blok.thousands} 000`}
                                suffix="&nbsp;000"
                            />
                            <Text showcased>{blok.line3}</Text>
                        </Stack>
                    </Stack>
                </Container>
            </FadeIn>
        </GridItem>
    )
}

export default DynamicEnergyHouseholds
